import { trigger, state, style, transition, animate } from '@angular/animations';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AlertController, LoadingController, ModalController, IonRouterOutlet, ToastController, Config } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { Subscription } from 'rxjs';
import { User } from 'src/assets/data/interfaces/interfaces-service';
import { FiltrosComponent } from '../modal/filtros/filtros.component';
import { ApiService } from '../services/api.service';
import { MqttService } from '../services/mqtt.service';
import { FontAwesomeService } from '../services/fontawesome.service';


@Component({
  selector: 'app-listado-ventas',
  templateUrl: './listado-ventas.page.html',
  styleUrls: ['./listado-ventas.page.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: "hidden" })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ListadoVentasPage implements OnInit {
  @ViewChild("paginator") paginator: MatPaginator;

  displayedColumns: string[] = ['proveedor', 'especie', 'cantidad', 'precio', 'importe'];
  displayedFooterColumns: string[] = ['proveedor', 'cantidad', 'importe'];

  /*,'star'*/
  isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('detailRow');
  dataAdjudica: any;
  dataSource;
  expandedElement: any;
  ventas: any = [];
  sortedData;
  fecha = new Date();
  fechaSend;
  //fechaSend = 'all'
  especieSend = "all";
  proveedorSend = "all";

  cantidadFinal;
  importeFinal;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  filteredProveedores: any;
  filteredEspecies: any;
  modalFiltro: HTMLIonModalElement;
  fechaInterval;
  fechaCabecera;

  user: User = {
    username: null,
    userId: null,
    clientes: null,
    roles: null,
  };


  subscriptions: Subscription[] = [];
  constructor(
    public alertCtrl: AlertController,
    public apiService: ApiService,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public router: Router,
    public datePipe: DatePipe,
    public dialog: MatDialog,
    public routerOutlet: IonRouterOutlet,
    public toastCtrl: ToastController,
    public config: Config,
    public storage: Storage,
    public mqttService: MqttService,
    public faService:FontAwesomeService
  ) {
    this.fechaInterval = setInterval(() => {
      this.fechaCabecera = new Date();
    }, 1000);
    this.fechaSend = this.datePipe.transform(new Date(), "dd-MM-yyyy");
  }

  onBlur(event) {
    this.fecha = event.value;
    this.fechaSend = this.fillLeft(String(event.value.date())) + "-" + this.fillLeft(String(event.value.month() + 1)) + "-" + event.value.year();
    this.getData(this.fechaSend )
  }
  fillLeft(text) {
    while (text.length < 2) {
      text = "0" + text;
    }
    return text;
  }
  ngOnInit() {
    this.storage.get("user").then(data => {
      this.user.username = data.username;
      this.user.userId = data.userId;
      this.user.clientes = data.clientes;
      this.user.roles = data.roles;
      this.getData(this.fechaSend );
    });
    if (this.dataSource) { this.dataSource.sort = this.sort; }
  }

  ionViewWillEnter() {
    this.storage.get("user").then(data => {
      this.user.username = data.username;
      this.user.userId = data.userId;
      this.user.clientes = data.clientes;
      this.user.roles = data.roles;
    });
  }

  ionViewDidLeave() {
    clearInterval(this.fechaInterval);
    this.subscriptions.forEach(sub => { sub.unsubscribe(); });
  }



  getData(fecha) {
    this.apiService.getAdj(fecha).subscribe((data: any) => {
        this.ventas = data
    });
  }


}
